// The wireframe's MetadataLine (wireframes/react/src/components/MetadataLine.tsx):
// labelled facts under a row's primary value — `Tip: SMTP   Destinație: …` — the
// label in tertiary grey, the value in secondary, 12/16, pairs 12px apart. The
// colon is written here, so the copy holds the bare label.
import type { ReactNode } from 'react';

export interface MetadataItem {
  label: string;
  value: ReactNode;
  /** The full value, for a value the line may cut short. */
  title?: string | undefined;
}

export interface MetadataLineProps {
  items: MetadataItem[];
  /** Let the pairs run onto a second line instead of cutting the last one short. */
  wrap?: boolean | undefined;
}

export function MetadataLine({ items, wrap = false }: MetadataLineProps): JSX.Element | null {
  const visible = items.filter((item) => item.value !== '' && item.value != null);
  if (visible.length === 0) return null;
  return (
    <dl className={`simsm-metadata-line${wrap ? ' simsm-metadata-line--wrap' : ''}`}>
      {visible.map((item, index) => (
        <div key={`${item.label}-${index}`} className="simsm-metadata-line__pair">
          <dt>{item.label}:</dt>
          <dd {...(item.title ? { title: item.title } : {})}>{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
